import { MENU_ITEM_KEYS, MENU_SECTION_KEYS } from 'features/account/user-menu/constants'

const hmMenuToggles = {
  [MENU_SECTION_KEYS.account]: {
    [MENU_ITEM_KEYS.purchases]: true,
    [MENU_ITEM_KEYS.donateVoucher]: true,
    [MENU_ITEM_KEYS.inviteFriendPage]: true,
    [MENU_ITEM_KEYS.pointsHistoryPage]: true,
    [MENU_ITEM_KEYS.paymentCredits]: true,
    [MENU_ITEM_KEYS.hmxklarna]: true,
    [MENU_ITEM_KEYS.hmxklarnaActivation]: true,
    [MENU_ITEM_KEYS.reviewItems]: true,
    [MENU_ITEM_KEYS.mySettings]: true,
  },
  [MENU_SECTION_KEYS.services]: {
    [MENU_ITEM_KEYS.digitalStylist]: true,
  },
  [MENU_SECTION_KEYS.help]: {
    [MENU_ITEM_KEYS.clubInfoPage]: true,
    [MENU_ITEM_KEYS.customerService]: true,
    [MENU_ITEM_KEYS.logout]: true,
  },
}

export default hmMenuToggles
